export const STAGES = [
  { id: "new", label: "New", color: "#007AFF", desc: "Just met, fresh lead" },
  { id: "warming", label: "Warming", color: "#FF9500", desc: "Initial follow-up sent" },
  { id: "engaged", label: "Engaged", color: "#BF5AF2", desc: "Active conversation" },
  { id: "active", label: "Active", color: "#34C759", desc: "Strong relationship" },
  { id: "dormant", label: "Dormant", color: "#525252", desc: "No recent contact" },
];

export const stageMeta = (id) => STAGES.find((s) => s.id === id) || STAGES[0];
